var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-select"},[_c('v-autocomplete',_vm._g(_vm._b({attrs:{"attach":".search-select","border-radius":"20"}},'v-autocomplete',_vm.$props,false),_vm.selectListeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }